export type AppInstance = "GENERAL" | "CHINA";

export const appInstance: AppInstance = import.meta.env.MODE.endsWith("-al") ? "CHINA" : "GENERAL";

export const isChinaInstance = appInstance === "CHINA";
